import { render } from "./component.vue?vue&type=template&id=065e4028&scoped=true&ts=true"
import script from "./component.vue?vue&type=script&lang=ts"
export * from "./component.vue?vue&type=script&lang=ts"

import "./component.vue?vue&type=style&index=0&id=065e4028&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065e4028"]])

export default __exports__